import React from "react";
import Navbar from "../Navbar/Navbar";
import Banner from "../Banner/Banner";
import OurVirtualTour from "../OurVirtualTour/OurVirtualTour";
import ShowCasingCapability from "../ShowCasingCapability/ShowCasingCapability";
import WhatWeDeliver from "../WhatWeDeliver/WhatWeDeliver";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";
import OurWorkFlow from "../OurWorkFlow/OurWorkFlow";
import Testimonials from "../Testimonials/Testimonials";
import FrequentlyAsked from "../FrequentlyAsked/FrequentlyAsked";
import ContactUs from "../ContactUs/ContactUs";
import Footer from "../Footer/Footer";

const MainPage = () => {
  return (
    <div className="mainpage-outer-wrapper">
      <div className="mainpage-inner-wrapper">
        {/* <Navbar /> */}
        <Banner />
        <OurVirtualTour />
        <ShowCasingCapability />
        <WhatWeDeliver />
        <WhyChooseUs />
        <OurWorkFlow />

        {/* <Testimonials /> */}

        <FrequentlyAsked />
        <ContactUs />

        <Footer />
      </div>
    </div>
  );
};

export default MainPage;
